// extracted by mini-css-extract-plugin
module.exports = {"vUiHue":"#ddd","wrapper":"TiledSelection__wrapper___zojLP","empty":"TiledSelection__empty___6c7-7","tooltip-wrapper":"TiledSelection__tooltip-wrapper___b+PHM"};